import * as THREE from 'three';

export function createButtons(material, positionX, positionY, positionZ, rotationX, rotationY, rotationZ, name) {
    const button = new THREE.Sprite(material);
    button.userData.name = name;
    button.position.set(positionX, positionY, positionZ);
    button.rotation.set(rotationX, rotationY, rotationZ);
    button.scale.set(0.5, 0.25, 0.5);
    button.visible = false;

    return button;
};

export function createLinkButtons(scene, material, positionX, positionY, positionZ, scaleX, scaleY, scaleZ, name, linkButtons, linkIndex) {
    const button = new THREE.Sprite(material);
    button.userData.name = name;
    button.position.set(positionX, positionY, positionZ);
    button.scale.set(scaleX, scaleY, scaleZ);
    button.visible = false;

    scene.add(button);
    linkButtons[linkIndex] = button;
}